module.exports = __webpack_public_path__ + "static/media/bgr-three-xxl.4ab3b460.webp";